import sendRequest from "../api/send/sendRequest";
import PrimaryButton from "../buttons/PrimaryButton";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import TextFieldEmail from "../textfields/TextFieldEmail";
import Modal1 from "./Modal1";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import SecondaryButton from "../buttons/SecondaryButton";
import Gleap from "gleap";

const ParticulierHeader = ({ prefix, email, phone }) => {
  const [signal_open, setSignalOpen] = useState(false);
  const [message, SetMessage] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSendRequest = async () => {
    const token = await getOrRefreshFirebaseToken();

    await sendRequest(
      "particulier",
      message,
      email,
      phone,
      "request",
      token,
      prefix
    );
    handleClickVariant("Message envoyé avec succès", "success");
    setSignalOpen(false);
  };

  return (
    <div className="flex flex-col  overflow-auto align-middle items-center justify-center bg-red-400">
      {/* Left Column: Takes all available space */}
      <Modal1 isOpen={signal_open} onClose={() => setSignalOpen(false)}>
        <div className="bg-white flex flex-col p-4 w-c400 rounded-xl ">
          <div className="flex flex-col gap-3 w-full">
            <TextFieldEmail
              label="Message"
              value={message}
              onChange={(e) => SetMessage(e.target.value)}
            ></TextFieldEmail>
            <div className="w-full gap-2 justify-end flex">
              <SecondaryButton
                className="w-fit"
                onClick={() => setSignalOpen(false)}
              >
                Annuler
              </SecondaryButton>
              <PrimaryButton className="w-fit" onClick={handleSendRequest}>
                Envoyer
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
    </div>
  );
};

export default ParticulierHeader;
